// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PsTRwDzLsaAs8gef3RCS{align-items:center;display:flex}.K77t1jHGBp8FvJlgbqtV{margin-left:12px;margin-right:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusLineWrapper": `PsTRwDzLsaAs8gef3RCS`,
	"estimateText": `K77t1jHGBp8FvJlgbqtV`
};
export default ___CSS_LOADER_EXPORT___;
